import React from "react";
import { FormattedMessage } from "react-intl";
import DataReports from "../data-reports";
import messages from "./personal-data-settings-messages";

import "./personal-data-settings.scss";
import DataReportingWithFlagon from "../data-reporting/data-reporting-with-flagon";
import AccountRemovalWithFlagOn from "../account-removal/account-removal-with-flag-on";

const PersonalDataSettingsWithFlagOn = () => {
  const sectionTitle = messages.sectionTitleWithFlag;

  const description = messages.sectionDescriptionWithFlag;
  return (
    <div className="personal-data-settings">
      <h2 className="personal-data-settings__title">
        <FormattedMessage {...sectionTitle} />
      </h2>
      <FormattedMessage {...description} />
      <DataReportingWithFlagon />
      <DataReports />
      <AccountRemovalWithFlagOn />
    </div>
  );
};

export default PersonalDataSettingsWithFlagOn;
